var _defs, _g, _path, _g2, _path2, _g3, _path3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPodcast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "9d9c432f0c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "76b7809009"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19 16 L 24 16 L 24 27.828125 L 19 27.828125 Z M 19 16 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6218cab09e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6 16 L 11 16 L 11 27.828125 L 6 27.828125 Z M 6 16 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1df1787305"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.457031 0.972656 L 28.308594 0.972656 L 28.308594 23 L 1.457031 23 Z M 1.457031 0.972656 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9d9c432f0c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdfbf9",
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 24.882812 19.355469 L 24.882812 25.441406 C 25.546875 25.207031 26.023438 24.570312 26.023438 23.828125 L 26.023438 20.96875 C 26.023438 20.226562 25.546875 19.589844 24.882812 19.355469 Z M 24.882812 19.355469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#76b7809009)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 22.597656 16.96875 L 20.882812 16.96875 C 20.253906 16.96875 19.738281 17.484375 19.738281 18.113281 L 19.738281 26.683594 C 19.738281 27.3125 20.253906 27.828125 20.882812 27.828125 L 22.597656 27.828125 C 23.226562 27.828125 23.738281 27.3125 23.738281 26.683594 L 23.738281 18.113281 C 23.738281 17.484375 23.226562 16.96875 22.597656 16.96875 Z M 22.597656 16.96875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 3.742188 20.96875 L 3.742188 23.828125 C 3.742188 24.570312 4.21875 25.207031 4.882812 25.441406 L 4.882812 19.355469 C 4.21875 19.589844 3.742188 20.226562 3.742188 20.96875 Z M 3.742188 20.96875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6218cab09e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 8.882812 16.96875 L 7.167969 16.96875 C 6.539062 16.96875 6.027344 17.484375 6.027344 18.113281 L 6.027344 26.683594 C 6.027344 27.3125 6.539062 27.828125 7.167969 27.828125 L 8.882812 27.828125 C 9.511719 27.828125 10.027344 27.3125 10.027344 26.683594 L 10.027344 18.113281 C 10.027344 17.484375 9.511719 16.96875 8.882812 16.96875 Z M 8.882812 16.96875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 22.308594 6.101562 C 18.074219 2.308594 11.6875 2.308594 7.457031 6.101562 C 8.035156 6.46875 8.777344 6.449219 9.339844 6.074219 C 12.671875 3.84375 17.082031 3.835938 20.425781 6.074219 C 20.988281 6.449219 21.730469 6.472656 22.308594 6.101562 Z M 22.308594 6.101562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1df1787305)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 14.882812 0.972656 C 7.480469 0.972656 1.457031 6.996094 1.457031 14.398438 L 1.457031 20.96875 C 1.457031 21.601562 1.96875 22.113281 2.597656 22.113281 C 2.597656 20.996094 2.597656 15.394531 2.597656 14.398438 C 2.597656 7.609375 8.09375 2.113281 14.882812 2.113281 C 21.671875 2.113281 27.167969 7.609375 27.167969 14.398438 C 27.167969 15.527344 27.167969 21.132812 27.167969 22.113281 C 27.796875 22.113281 28.308594 21.601562 28.308594 20.96875 L 28.308594 14.398438 C 28.308594 6.996094 22.285156 0.972656 14.882812 0.972656 Z M 14.882812 0.972656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodcast);
export default __webpack_public_path__ + "static/media/podcast.5d7b6d830a8ca5ac5e053fb23ec01f71.svg";
export { ForwardRef as ReactComponent };